import { useSafeState, useToggle, useIntervalEffect } from "@react-hookz/web";
import { useEffect } from "react";

export const SEND_CODE_TIMEOUT_IN_SECONDS = 30;
export const UPDATE_INTERVAL_IN_MS = 1000;

const useVerificationCodeTimeOut = (initialState = true) => {
  const [secondsLeft, setSecondsLeft] = useSafeState<number>(
    SEND_CODE_TIMEOUT_IN_SECONDS,
  );
  const [enabled, toggleEnabled] = useToggle(initialState);
  useEffect(() => {
    if (!enabled) {
      setSecondsLeft(SEND_CODE_TIMEOUT_IN_SECONDS);
    }
  }, [enabled, setSecondsLeft]);

  useIntervalEffect(
    () => {
      if (secondsLeft <= 1) {
        toggleEnabled(false);
      } else {
        setSecondsLeft((last) => last - 1);
      }
    },
    enabled ? UPDATE_INTERVAL_IN_MS : undefined,
  );

  return { secondsLeft, toggleEnabled, enabled };
};

export default useVerificationCodeTimeOut;
